import { css } from '@emotion/react'

const S = {
  basic: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    > label {
      margin: 0 4px;
    }
    > label:last-of-type {
      margin-right: 0;
      margin-left: 4px;
    }
    > label:first-of-type {
      margin-left: 0;
      margin-right: 4px;
    }

    > .radio-label {
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  `,
  size: {
    auto: css`
      > label {
        height: auto;
      }
    `,
    small: css`
      > label {
        height: 40px;
      }
    `,
    medium: css`
      > label {
        height: 54px;
      }
    `,
    large: css`
      > label {
        height: 90px;
      }
    `,
  },
}

export default S
